import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import PropTypes from "prop-types";
import React from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Skeleton from "@material-ui/lab/Skeleton";

import {formatNumber} from "../../utils/formatNumber";

const useStyles = makeStyles((theme) => ({
  card: {
    border: "1px solid #D3D3D3",
    boxShadow: "0 2px 4px 0 rgba(0,0,0,0.2)",
  },
  content: {
    position: "relative",
    paddingTop: "25.5px",
    paddingBottom: "19.5px !important",
    "&:last-child": {
      paddingBottom: theme.spacing(1) * 2,
    },
    [theme.breakpoints.down("sm")]: {
      padding: "21.5px 32px 19.5px",
    },
  },
  icon: {
    boxShadow: "none",
    color: "white",
    opacity: "0.75",
    padding: 0,
    marginBottom: "13px",
    [theme.breakpoints.down("sm")]: {
      marginBottom: 0,
      marginRight: "24px",
    },
  },
  iconFloat: {
    position: "absolute",
    right: "15px",
    top: "50%",
    marginTop: "-20px",
    opacity: "0.2",
    transform: "rotate(-5deg)",
  },
  title: {
    fontSize: "1.25rem",
    fontWeight: "500",
    letterSpacing: "-0.4px",
    lineHeight: "22px",
  },
  subTitle: {
    fontSize: "1rem",
    lineHeight: "22px",
    letterSpacing: "-0.4px",
  },
  blackText: {
    color: "#212121",
  },
  grayText: {
    color: "#757575",
    fontSize: "2.80rem",
    letterSpacing: "-0.9px",
    [theme.breakpoints.down("md")]: {
      fontSize: "2rem",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "2.80rem",
    },
  },
  percentage: {
    fontSize: "1.55rem",
    color: "#39B8CD",
    display: "block",
    fontWeight: 500,
    lineHeight: 1.9,
    letterSpacing: "-0.3px",
  },
  percentageText: {
    display: "block",
    fontSize: "0.94rem",
    color: "#39B8CD",
    lineHeight: "18px",
    letterSpacing: "-0.3px",
  },
  direction: {
    flexDirection: "column",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "row",
      flexWrap: "nowrap",
    },
  },
  textDirection: {
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      textAlign: "left",
    },
  },
}));

const StatCardThin = (props) => {
  const {
    type,
    title,
    value,
    icon,
    color,
    secondValue,
    percentage,
    percentageText,
    difColor,
    textCenter,
    loading,
  } = props;

  const classes = useStyles(props);
  let before = null;
  let after = null;

  const formattedPercentage = percentage ? `${percentage}%` : `0%`;


  const cardIcon = (
    <Grid item className={type === "fill" ? classes.iconFloat : null}>
      <IconButton
        className={classes.icon}
        aria-label={title}
        style={{ backgroundColor: color, cursor: "auto" }}
      >
        {icon}
      </IconButton>
    </Grid>
  );

  if (icon) {
    type === "fill" ? (after = cardIcon) : (before = cardIcon);
  }

  return (
    <Card
      classes={{ root: classes.card }}
      style={
        (type === "fill" ? { backgroundColor: color } : null,
        textCenter ? { textAlign: "center" } : null)
      }
    >
      <CardContent className={classes.content}>
        <Grid
          container
          className={classes.direction}
          alignItems={"center"}
          justify={"center"}
        >
          {before}
          <Grid item className={classes.textDirection}>
            <div style={{overflowWrap:'anywhere'}}>
              <Typography
                variant="caption"
                className={(classes.blackText, classes.title)}
              >
                {loading ? <Skeleton /> : `${value}`}
              </Typography>
              {secondValue && (
                <Typography
                  variant="h6"
                  className={(classes.blackText, classes.subTitle)}
                >
                  {loading ? <Skeleton /> : `${secondValue}`}
                </Typography>
              )}
              <Typography variant="h3" className={classes.grayText}>
                {loading ? <Skeleton /> : `${formatNumber(title)}`}
              </Typography>

            
                <Typography
                  variant="caption"
                  className={classes.percentage}
                  style={difColor ? { color: color } : null}
                >
                  {loading ? <Skeleton /> : `${formattedPercentage}`}
                </Typography>
              
              {percentageText && (
                <Typography
                  variant="caption"
                  className={classes.percentageText}
                  style={difColor ? { color: color } : null}
                >
                  {loading ? <Skeleton width={100}/> : `${percentageText}`}
                </Typography>
              )}
            </div>
          </Grid>
          {after}
        </Grid>
      </CardContent>
    </Card>
  );
};

StatCardThin.defaultProps = {
  title: 0
};

StatCardThin.propTypes = {
  type: PropTypes.oneOf(["fill"]),
  title: PropTypes.number,
  value: PropTypes.string,
  icon: PropTypes.element,
  color: PropTypes.string,
};

export default StatCardThin;
